import { render, staticRenderFns } from "./how-to.vue?vue&type=template&id=f2768eac&scoped=true&"
import script from "./how-to.vue?vue&type=script&lang=js&"
export * from "./how-to.vue?vue&type=script&lang=js&"
import style0 from "./how-to.vue?vue&type=style&index=0&id=f2768eac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2768eac",
  null
  
)

export default component.exports